"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDeviceType = void 0;
var getDeviceType = function () {
    var userAgent = window.navigator.userAgent.toLowerCase();
    var isWebView = userAgent.includes('wv');
    if (!isWebView) {
        return 'Web';
    }
    var isAndroid = userAgent.includes('android');
    if (isAndroid) {
        return 'Android';
    }
    return 'iOS';
};
exports.getDeviceType = getDeviceType;
//# sourceMappingURL=getDeviceType.js.map